import { Hour12Format, formatDate } from 'src/app/utils/date-utils';
import { map, catchError, throwError } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { LiveActivityService } from 'src/app/services/live-activity.service';
import { ConfirmationModalComponent } from 'src/app/components/common/confirmation-modal/confirmation-modal.component';
import { MatDialog } from '@angular/material/dialog';

type Stuct = { [dateTimeString: string]: any }

@Component({
  selector: 'app-live-activities',
  templateUrl: './live-activities.component.html',
  styleUrls: ['./live-activities.component.scss']
})
export class LiveActivitiesComponent implements OnInit {

  liveActivitiesByDate: Stuct = {};
  ngOnInit(): void {
    this.getActivity();
  }

  constructor(private liveActivity: LiveActivityService, private dialog: MatDialog) {
  }

  getActivity() {
    // this.liveActivity.getActiveActivity().subscribe((res:any)=>{
    //   this.liveActivityList=res.details
    // })
    this.liveActivity.getActiveActivity().pipe(
      map((res: any) => {
        res.details.forEach((element: any) => {
          const dateTimeString = formatDate(element.event_datetime)
          if (this.liveActivitiesByDate.hasOwnProperty(dateTimeString)) {
            this.liveActivitiesByDate[dateTimeString].push(element)
          } else {
            this.liveActivitiesByDate[dateTimeString] = [element]
          }
        });
      }),
      catchError(error => {
        return throwError(error.massage || error)
      })
    ).subscribe()

  }

  getObjectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  getTime(date: string): string {
    // console.log(date)
    return Hour12Format(date);
  }

  getDayOfWeek(dateString: string): string {
    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const date = new Date(dateString);
    return daysOfWeek[date.getDay()];
  }

  openDialog() {
    this.dialog.open(ConfirmationModalComponent, {
      enterAnimationDuration: '350ms',
      data: {
        error: null
      }
    })
  }

}
